import axios from "axios";
import axiosRetry from "axios-retry";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "https://server.fleeby.in",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosRetry(axiosInstance, {
  retries: 2,
  retryDelay: (retryCount) => retryCount * 1000,
  retryCondition: (error) => error.response?.status >= 500,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;

  // if (import.meta.env.DEV)
  //   console.log(`[Axios] ${config.method?.toUpperCase()} ${config.url}`);

  return config;
});

let onUnauthorized: (() => void) | null = null;

export const setUnauthorizedHandler = (callback: () => void) => {
  onUnauthorized = callback;
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    if (status === 401) {
      // console.log("Unauthorized detected:", url);

      const allowedAnonymousPaths = [
        "/api/products/",
        "/api/cart-items/",
        "/api/categories/",
      ];

      const isAllowedAnonymous = allowedAnonymousPaths.some((path) =>
        url.startsWith(path)
      );

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      if (!isAllowedAnonymous && typeof onUnauthorized === "function") {
        onUnauthorized();
      }

      return Promise.resolve({ unauthorized: true });
    }

    return Promise.reject(error);
  }
);

export const fetcher = async (url: string) => {
  const res = await axiosInstance.get(url);
  return res.data;
};

export default axiosInstance;
